import React, { useState } from 'react';
import { Paperclip, X, Trash2 } from 'lucide-react';

import { ItemPath } from '../../../../order.schema';
import { useAttachmentHandler } from '../../../../Hooks/useAttachmentHandler';
import AttachmentSourceModal from '../../../../../../../../components/AttachmentSourceModal';
import AttachmentGalleryModal, { GalleryFile } from '../../../../../../../../components/AttachmentGalleryModal';

import {
  FormGroup,
  Label,
  AttachmentList,
  AttachmentListItem,
  RemoveAttachmentButton,
  FormErrorMessage,
  AttachmentInputContainer,
  AttachmentTrigger,
  AttachmentPlaceholder,
  TrashIconContainer,
} from '../../../../style';

interface ProductAttachmentCellProps {
  itemPath: ItemPath;
}

const ProductAttachmentCell: React.FC<ProductAttachmentCellProps> = ({ itemPath }) => {
  const [isSourceChoiceOpen, setIsSourceChoiceOpen] = useState(false);
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);

  const {
    attachments,
    attachmentError,
    fileInputRef,
    handleFileSelectClick,
    handleFileChange,
    handleSelectFromGallery,
    handleRemoveAttachment,
    handleRemoveAllAttachments,
  } = useAttachmentHandler({ fieldPath: `${itemPath}.finalProduct.anexos` });

  return (
    <FormGroup>
      <Label>Arquivo</Label>
      <AttachmentInputContainer>
        <AttachmentTrigger onClick={() => setIsSourceChoiceOpen(true)} hasError={!!attachmentError}>
          <Paperclip size={16} />
          <AttachmentPlaceholder>Clique para anexar arquivos</AttachmentPlaceholder>
        </AttachmentTrigger>
        {attachments.length > 0 && (
          <TrashIconContainer
            as="button"
            type="button"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleRemoveAllAttachments();
            }}
          >
            <Trash2 size={16} />
          </TrashIconContainer>
        )}
      </AttachmentInputContainer>
      {attachments.length > 0 && (
        <AttachmentList>
          {attachments.map((file, index) => (
            <AttachmentListItem key={index}>
              {file.name}
              <RemoveAttachmentButton
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleRemoveAttachment(index);
                }}
              >
                <X size={12} />
              </RemoveAttachmentButton>
            </AttachmentListItem>
          ))}
        </AttachmentList>
      )}
      <input
        type="file"
        multiple
        ref={fileInputRef}
        onChange={handleFileChange}
        style={{ display: 'none' }}
        accept=".pdf,.xml,.doc,.docx,.xls,.xlsx,.jpeg,.jpg,.png"
      />
      {attachmentError && <FormErrorMessage>{attachmentError}</FormErrorMessage>}

      <AttachmentSourceModal
        isOpen={isSourceChoiceOpen}
        onClose={() => setIsSourceChoiceOpen(false)}
        title="Adicionar Anexo ao Item"
        description="Escolha como deseja adicionar os arquivos ao item:"
        onChooseUpload={() => {
          handleFileSelectClick();
        }}
        onChooseGallery={() => {
          setIsGalleryOpen(true);
        }}
      />

      <AttachmentGalleryModal
        isOpen={isGalleryOpen}
        onClose={() => setIsGalleryOpen(false)}
        multiple={true}
        title="Galeria da Empresa - Anexos"
        onSelect={(files: GalleryFile[]) => {
          handleSelectFromGallery(files);
        }}
      />
    </FormGroup>
  );
};

export default ProductAttachmentCell;
